module.exports = __webpack_public_path__ + "static/create_calendar_context_menu-73e4578e9a1290daab9921c227d6a0d5.png";